import { render, staticRenderFns } from "./CaptureNationalIdBack.vue?vue&type=template&id=4f7bc7b6&"
import script from "./CaptureNationalIdBack.vue?vue&type=script&lang=ts&"
export * from "./CaptureNationalIdBack.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports